import { ElectronApi } from '@/services/electron.api';
import naturalCompare from 'string-natural-compare';

export const sortFilenames = (images: string[]) => images.sort(naturalCompare);

export const matchFilenames = (
  images: string[],
  targets: { label: string; validator?: (s: string) => boolean }[]
): string[] => {
  const { path } = ElectronApi;
  if (!path) return [];
  // 匹配到targets
  const matched: (string | null)[] = [];
  for (const target of targets) {
    const validator =
      target.validator ?? ((s: string) => s.includes(target.label));
    // 使用basename 防止路径中的字符影响排序结果
    const m = images.find((s: string) => validator(path.basename(s)));
    if (m) {
      matched.push(m);
      images.splice(images.indexOf(m), 1);
    } else {
      matched.push(null);
    }
  }
  let res: string[] = [];
  // 补全未匹配项, 其余项拼接到最后
  images.sort(naturalCompare);
  for (const item of matched)
    res.push(item ? item : (images.shift() as string));
  res = [...res, ...images];
  return res;
};

/**
 * 返回唯一的theme名称
 * @returns
 */
export const uniqueName = (existsNames: string[], basename: string) => {
  const reg = /\d{1,}$/g;
  const res = basename.match(reg);
  let flag = +(res?.[0] ?? 0);
  const flag2 = flag;
  let _basename = basename;
  basename = basename.replace(/\d{1,}$/g, '');

  existsNames.sort((a, b) => {
    const reg = /(?<=.*)\d{1,}$/;
    const _a = a.match(reg)?.[0] ?? 0;
    const _b = b.match(reg)?.[0] ?? 0;
    return Number(_a) - Number(_b);
  });

  existsNames.forEach((existsName: string) => {
    if (existsName == _basename) {
      flag++;
      _basename = flag > flag2 ? basename + '' + flag : basename;
    }
  });

  return _basename;
};

/**
 * 检查文件名，是否重复。如重复则增加标识
 * @param filename
 */
export const uniqueFileName = async (dir: string, basename: string) => {
  const path = ElectronApi.path;
  const fs = ElectronApi.fs;
  if (!path || !fs) return;
  const basenames = await fs.promises.readdir(dir);

  return uniqueName(basenames, basename);
};

/**
 * 返回文件名列表的公共前缀长度
 * @param filenames string[]
 */
export const publicPrefixLength = (filenames: string[]) => {
  if (!filenames.length) return 0;
  let len = 0;
  while (filenames.every((i) => i.startsWith(filenames[0].substring(0, len))))
    len++;
  return len - 1;
};
